/*
 * Outdoor Living parts finder (shadow build, DEV theme only).
 * Two ways in: "Find by my tub" (product type, brand, range, year) and "Find by the part" (part type).
 * Data: window.OLPARTS (parts feed) and window.OLTUBS (UK tub register).
 * Hub mode renders the finder and grid. Product mode renders the fit panel on a part's page.
 */
(function () {
  'use strict';

  var PHONE = '01482 212322';
  var TEL = 'tel:01482212322';
  var STORE_KEY = 'olp-my-tub';
  var PAGE = 24;

  var TYPE_META = {
    'Pumps & pump parts': { slug: 'pumps', icon: 'oli-ol-pump', short: 'Pumps' },
    'Heaters': { slug: 'heaters', icon: 'oli-p-heater', short: 'Heaters' },
    'Jets & jet faces': { slug: 'jets', icon: 'oli-ol-jets', short: 'Jets' },
    'Control panels & circuit boards': { slug: 'control-panels', icon: 'oli-p-panel', short: 'Control panels' },
    'Sensors, switches & wiring': { slug: 'sensors', icon: 'oli-p-sensor', short: 'Sensors and switches' },
    'Diverters, air controls & waterfalls': { slug: 'diverters', icon: 'oli-p-diverter', short: 'Diverters and waterfalls' },
    'Drains, valves & plumbing': { slug: 'plumbing', icon: 'oli-p-drain', short: 'Drains and plumbing' },
    'Filtration, UV & ozone': { slug: 'filtration', icon: 'oli-filter', short: 'Filtration, UV and ozone' },
    'Lights': { slug: 'lights', icon: 'oli-ol-led-lighting', short: 'Lights' },
    'Audio': { slug: 'audio', icon: 'oli-p-audio', short: 'Speakers and audio' },
    'Pillows & headrests': { slug: 'pillows', icon: 'oli-ol-no-of-headrests', short: 'Pillows' },
    'Seals, O-rings & gaskets': { slug: 'seals', icon: 'oli-p-seal', short: 'Seals and O-rings' },
    'Trims, cupholders & fixings': { slug: 'trims', icon: 'oli-drinks-holder', short: 'Trims and fixings' }
  };

  var SIGNS = {
    'Pumps & pump parts': ['Jets weak or not running', 'Pump hums but does not turn', 'Water dripping under the pump'],
    'Heaters': ['Water not warming up', 'Heater or flow error on the panel', 'Electrics tripping when it heats'],
    'Jets & jet faces': ['Jet face cracked or missing', 'Jet will not turn or adjust', 'Little or no flow from one jet'],
    'Control panels & circuit boards': ['Display blank or flickering', 'Buttons not responding', 'Error codes that keep coming back'],
    'Sensors, switches & wiring': ['Flow or temperature errors', 'Pump runs but the tub will not heat', 'Readings that jump around'],
    'Diverters, air controls & waterfalls': ['Knob stiff, loose or snapped', 'Water will not move between jet groups', 'Waterfall not flowing'],
    'Drains, valves & plumbing': ['Drips around a fitting or valve', 'Drain valve will not close', 'Cracked pipe or fitting'],
    'Filtration, UV & ozone': ['Cloudy water even with chemicals', 'Skimmer, basket or weir cracked', 'UV or ozone light not on'],
    'Lights': ['Light not coming on', 'Colours stopped changing', 'Lens cracked or misted'],
    'Audio': ['No sound from a speaker', 'Stereo will not power on', 'Crackle or distortion'],
    'Pillows & headrests': ['Pillow cracked, faded or loose', 'Pillow will not stay in place'],
    'Seals, O-rings & gaskets': ['Drips from a union or fitting', 'Seal flattened, split or perished'],
    'Trims, cupholders & fixings': ['Trim cracked or missing', 'Cupholder or fixing loose']
  };

  var BRAND_LOGOS = {};
  var TYPE_ORDER = Object.keys(TYPE_META);
  function typeRank(pt) { var i = TYPE_ORDER.indexOf(pt); return i < 0 ? 99 : i; }

  /* Each part type's own collection page (the page that ranks for that part). Types without one stay on the main parts page. */
  var HUB_HANDLE = 'hot-tub-parts';
  var TYPE_PAGES = {
    pumps: 'pumps-parts', heaters: 'heaters-parts', jets: 'jets', 'control-panels': 'topside-control-panels',
    sensors: 'sensors', plumbing: 'plumbing-filtration', filtration: 'clearray-uv-and-ozone', lights: 'lights',
    audio: 'speakers-stereo', pillows: 'pillows', seals: 'o-rings-gaskets'
  };

  /* A link to another parts page that keeps the shopper's tub (and the test view while on DEV). */
  function pageUrl(handle, tub, extra) {
    var q = new URLSearchParams();
    var now = new URLSearchParams(location.search);
    if (now.get('view') === 'parts') q.set('view', 'parts');
    if (now.get('preview_theme_id')) q.set('preview_theme_id', now.get('preview_theme_id'));
    if (tub && tub.brand) {
      if (tub.pt) q.set('pt', slug(tub.pt));
      q.set('brand', slug(tub.brand));
      if (tub.range) q.set('range', slug(tub.range));
      if (tub.year) q.set('year', slug(tub.year));
    }
    if (extra) Object.keys(extra).forEach(function (k) { q.set(k, extra[k]); });
    var qs = q.toString();
    return '/collections/' + handle + (qs ? '?' + qs : '');
  }
  function typeUrl(typeKey, tub) {
    var m = TYPE_META[typeKey];
    if (!m) return pageUrl(HUB_HANDLE, tub);
    return TYPE_PAGES[m.slug] ? pageUrl(TYPE_PAGES[m.slug], tub) : pageUrl(HUB_HANDLE, tub, { type: m.slug });
  }

  /* Live list of a collection's products, so every page shows exactly its own parts, and new parts appear before the finder data is rebuilt. */
  function loadCollection(handle, done) {
    var out = [], page = 1;
    function next() {
      fetch('/collections/' + handle + '/products.json?limit=250&page=' + page, { credentials: 'same-origin' })
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
        .then(function (j) {
          var ps = (j && j.products) || [];
          out = out.concat(ps);
          if (ps.length === 250 && page < 8) { page++; next(); } else done(out);
        })
        .catch(function () { done(null); });
    }
    next();
  }

  /* A part that is on the site but not yet in the finder data: shown with what the store knows.
     Its fit comes from the product's "Fits ..." tags, so a new part gets fit labels as soon as it is tagged. */
  var MAKERS = { 'Jacuzzi': 'Genuine Jacuzzi', 'Arctic': 'Genuine Arctic Spas', 'Arctic Spas': 'Genuine Arctic Spas', 'Balboa': 'Genuine Balboa', 'Artesian': 'Genuine Artesian', 'Superior': 'Superior Wellness', 'Outdoor Living': '' };
  var GUESS = [
    [/speaker|stereo|subwoofer|audio|bluetooth/i, 'Audio'],
    [/o-?ring|gasket|\bseal|washer/i, 'Seals, O-rings & gaskets'],
    [/topside|control panel|circuit|pcb|motherboard|power pack|wi-?fi|remote/i, 'Control panels & circuit boards'],
    [/flow switch|pressure switch|sensor|probe|fuse|cable|cord|wiring/i, 'Sensors, switches & wiring'],
    [/\blight\b/i, 'Lights'],
    [/pillow|headrest/i, 'Pillows & headrests'],
    [/divert-a-jet/i, 'Jets & jet faces'],
    [/divert|air control|waterfall/i, 'Diverters, air controls & waterfalls'],
    [/\bjet/i, 'Jets & jet faces'],
    [/\bled\b|\blens/i, 'Lights'],
    [/heater|element/i, 'Heaters'],
    [/filter|skimmer|\buv\b|ozone|clearray|weir|quartz|canister|float/i, 'Filtration, UV & ozone'],
    [/grate|drain|valve|pipe|union|fitting|elbow|cement|glue|hose/i, 'Drains, valves & plumbing'],
    [/pump|wet end|capacitor/i, 'Pumps & pump parts'],
    [/cupholder|trim|screw|\bnut\b|clip|aromatherapy/i, 'Trims, cupholders & fixings']
  ];
  /* best guess from the part's name (the words before "for ..."); a type page always uses its own type */
  var TAG_TYPES = {
    'type_pump': 'Pumps & pump parts', 'type_pump part': 'Pumps & pump parts', 'type_heater': 'Heaters', 'type_jet': 'Jets & jet faces',
    'type_topside control panel': 'Control panels & circuit boards', 'type_circuit board': 'Control panels & circuit boards', 'type_electrics': 'Control panels & circuit boards',
    'type_sensor': 'Sensors, switches & wiring', 'type_flow switch': 'Sensors, switches & wiring', 'type_pressure switch': 'Sensors, switches & wiring',
    'type_plumbing': 'Drains, valves & plumbing', 'type_filtration': 'Filtration, UV & ozone', 'type_ozone': 'Filtration, UV & ozone', 'type_uv': 'Filtration, UV & ozone', 'type_clearray': 'Filtration, UV & ozone',
    'type_light': 'Lights', 'type_speaker': 'Audio', 'type_stereo': 'Audio', 'type_pillow': 'Pillows & headrests', 'type_o-ring & gasket': 'Seals, O-rings & gaskets'
  };
  function tagList(tags) { return typeof tags === 'string' ? tags.split(/,\s*/) : tags || []; }
  function guessType(title, tags) {
    var name = String(title || '').split(/ for /i)[0];
    for (var i = 0; i < GUESS.length; i++) if (GUESS[i][0].test(name)) return GUESS[i][1];
    var hit = null;
    tagList(tags).forEach(function (t) { if (!hit && TAG_TYPES[t]) hit = TAG_TYPES[t]; });
    return hit;
  }
  function fitsFromTags(tags) {
    var brands = {}, out = [], ranged = {};
    R.forEach(function (r) { brands[r.brand] = 1; });
    var names = Object.keys(brands).sort(function (a, b) { return b.length - a.length; });
    tagList(tags).forEach(function (tag) {
      if (/^universal fit$/i.test(tag)) { out.push({ product_type: 'Hot tub', brand: 'Universal' }); return; }
      var m = /^Fits (.+)$/.exec(tag);
      if (!m) return;
      var rest = m[1], brand = null;
      for (var i = 0; i < names.length; i++) if (rest === names[i] || rest.indexOf(names[i] + ' ') === 0) { brand = names[i]; break; }
      if (!brand) return;
      var rname = rest.slice(brand.length).trim().toLowerCase();
      var hit = null;
      if (rname) R.forEach(function (r) { if (r.brand === brand && r.range.toLowerCase() === rname) hit = r; });
      if (hit) { out.push({ product_type: hit.product_type, brand: brand, range: hit.range }); ranged[brand] = 1; return; }
      var pts = {};
      R.forEach(function (r) { if (r.brand === brand) pts[r.product_type] = 1; });
      out.push({ product_type: pts['Hot tub'] ? 'Hot tub' : 'Swim spa', brand: brand });
    });
    /* "Fits Jacuzzi" plus "Fits Jacuzzi J300" means J300 only */
    var seen = {};
    return out.filter(function (f) {
      var k = f.product_type + '|' + f.brand + '|' + (f.range || '');
      if (seen[k]) return false;
      seen[k] = 1;
      return f.range || f.brand === 'Universal' || !ranged[f.brand];
    });
  }
  function partFromProduct(pr, pageType) {
    var vs = pr.variants || [];
    var v = vs[0] || {};
    var img = pr.images && pr.images[0] ? pr.images[0].src : null;
    var maker = MAKERS.hasOwnProperty(pr.vendor) ? MAKERS[pr.vendor] : (pr.vendor || '');
    return {
      h: pr.handle, t: pr.title, old: '', pt: pageType || guessType(pr.title, pr.tags), s: maker, n: v.sku || '', f: fitsFromTags(pr.tags), img: img,
      price: Number(v.price || 0), compare: v.compare_at_price ? Number(v.compare_at_price) : null,
      avail: vs.some(function (x) { return x.available; })
    };
  }

  /* ---------- helpers ---------- */

  function el(tag, attrs, kids) {
    var n = document.createElement(tag);
    if (attrs) {
      for (var k in attrs) {
        if (!Object.prototype.hasOwnProperty.call(attrs, k)) continue;
        var v = attrs[k];
        if (v === null || v === undefined || v === false) continue;
        if (k === 'class') n.className = v;
        else if (k === 'text') n.textContent = v;
        else if (k === 'html') n.innerHTML = v;
        else if (k.indexOf('on') === 0 && typeof v === 'function') n.addEventListener(k.slice(2), v);
        else n.setAttribute(k, v === true ? '' : v);
      }
    }
    (kids || []).forEach(function (c) {
      if (c === null || c === undefined || c === false) return;
      n.appendChild(typeof c === 'string' ? document.createTextNode(c) : c);
    });
    return n;
  }

  function icon(id, w, h) {
    var ns = 'http://www.w3.org/2000/svg';
    var s = document.createElementNS(ns, 'svg');
    s.setAttribute('class', 'ol-i olp-ic');
    s.setAttribute('width', w || 30);
    s.setAttribute('height', h || 20);
    s.setAttribute('aria-hidden', 'true');
    s.setAttribute('focusable', 'false');
    var u = document.createElementNS(ns, 'use');
    u.setAttribute('href', '#' + id);
    s.appendChild(u);
    return s;
  }

  function slug(s) {
    return String(s || '').toLowerCase().replace(/&/g, 'and').replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
  }

  function money(n) {
    return '£' + Number(n).toLocaleString('en-GB', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }

  function norm(s) {
    return String(s || '').toLowerCase().replace(/[®™]/g, '').replace(/j-(\d)/g, 'j$1').replace(/[^a-z0-9]+/g, ' ').trim();
  }

  function yearRange(s) {
    if (!s) return null;
    s = String(s);
    var m = s.match(/^Before (\d{4})$/);
    if (m) return [0, +m[1] - 1];
    m = s.match(/^(\d{4})-(\d{4})$/);
    if (m) return [+m[1], +m[2]];
    m = s.match(/^(\d{4}) onwards$/);
    if (m) return [+m[1], 9999];
    m = s.match(/^(\d{4})$/);
    if (m) return [+m[1], +m[1]];
    return null;
  }

  function overlaps(a, b) {
    if (!a || !b) return true;
    return a[0] <= b[1] && b[0] <= a[1];
  }

  function store(get, val) {
    try {
      if (get) return JSON.parse(localStorage.getItem(STORE_KEY) || 'null');
      if (val) localStorage.setItem(STORE_KEY, JSON.stringify(val));
      else localStorage.removeItem(STORE_KEY);
    } catch (e) { return null; }
  }

  function tubLabel(t) {
    if (!t || !t.brand) return '';
    var s = t.brand;
    if (t.range === 'Current range') s += ' (current range)';
    else if (t.range && t.range.indexOf(t.brand) !== 0) s += ' ' + t.range;
    else if (t.range) s = t.range;
    if (t.year) s += ', ' + t.year.replace(/^Before/, 'before');
    return s;
  }

  /* ---------- data ---------- */

  var D = window.OLPARTS || { parts: [], types: [] };
  var R = (window.OLTUBS && window.OLTUBS.ranges) || [];

  function rangesFor(pt, brand) {
    return R.filter(function (r) { return r.brand === brand && (!pt || r.product_type === pt); });
  }

  function brandCounts(pt) {
    var c = {};
    D.parts.forEach(function (p) {
      var seen = {};
      p.f.forEach(function (f) {
        if (!f.brand || f.brand === 'Universal') return;
        if (pt && (f.product_type || 'Hot tub') !== pt) return;
        if (!seen[f.brand]) { c[f.brand] = (c[f.brand] || 0) + 1; seen[f.brand] = 1; }
      });
    });
    return c;
  }

  function brandOrder(pt) {
    var c = brandCounts(pt);
    var all = {};
    R.forEach(function (r) { if (!pt || r.product_type === pt) all[r.brand] = 1; });
    Object.keys(c).forEach(function (b) { all[b] = 1; });
    return Object.keys(all).sort(function (a, b) {
      var ra = a === 'Outdoor Living' ? 0 : a === 'Edge' ? 1 : 2;
      var rb = b === 'Outdoor Living' ? 0 : b === 'Edge' ? 1 : 2;
      if (ra !== rb) return ra - rb;
      if ((c[b] || 0) !== (c[a] || 0)) return (c[b] || 0) - (c[a] || 0);
      return a.localeCompare(b);
    }).map(function (b) { return { brand: b, count: c[b] || 0 }; });
  }

  /* How a part relates to the chosen tub:
     'fit'       made for this brand and range (and year, when both are known)
     'brand'     listed for the brand with no range, so the customer should check with us
     'universal' standard part that suits most tubs of this type
     null        not for this tub; 'any' when no tub is chosen */
  function fitLevel(p, tub) {
    if (!tub || !tub.brand) return 'any';
    var fit = false, brandOnly = false, uni = false;
    var want = yearRange(tub.year);
    p.f.forEach(function (f) {
      if (tub.pt && f.product_type && f.product_type !== tub.pt) return;
      if (f.brand === 'Universal') { uni = true; return; }
      if (f.brand !== tub.brand) return;
      if (!overlaps(yearRange(f.years), want)) return;
      if (!tub.range) { fit = true; return; }
      if (f.range === tub.range) { fit = true; return; }
      if (!f.range) brandOnly = true;
    });
    return fit ? 'fit' : brandOnly ? 'brand' : uni ? 'universal' : null;
  }

  /* One count used everywhere (brand tiles, type chips, results) so the numbers always agree. */
  function tally(tub, type) {
    var c = { fit: 0, brand: 0, universal: 0, total: 0 };
    D.parts.forEach(function (p) {
      if (type && p.pt !== type) return;
      var l = fitLevel(p, tub);
      if (l === 'any') { c.total++; return; }
      if (l) { c[l]++; c.total++; }
    });
    return c;
  }

  /* The tub a brand choice leads to: its range is filled in when the brand has only one. */
  function tubForBrand(pt, brand) {
    var rs = rangesFor(pt, brand);
    /* a single catch-all range ("Hot Spring hot tubs") is the same as the whole brand */
    var one = rs.length === 1 && !/ (hot tubs|swim spas)$/.test(rs[0].range) ? rs[0].range : null;
    return { pt: pt, brand: brand, range: one, year: null };
  }

  function fitSummary(p, max) {
    var groups = {};
    var order = [];
    var universal = false;
    p.f.forEach(function (f) {
      if (f.brand === 'Universal') { universal = true; return; }
      if (!f.brand) return;
      if (!groups[f.brand]) { groups[f.brand] = []; order.push(f.brand); }
      var bit = '';
      if (f.models && f.models.length && f.models.length <= 3) bit = (f.product_type === 'Swim spa' && f.range ? f.range + ' ' : '') + f.models.join(', ').replace(/J-(\d)/g, 'J$1');
      else if (f.range && f.range.indexOf(f.brand) !== 0 && !/hot tubs|earlier models/.test(f.range)) bit = f.range;
      else if (f.models && f.models.length) bit = f.models.slice(0, 3).join(', ');
      if (f.years && !/^V\d|^\d{4}$/.test(f.years)) bit += (bit ? ' ' : '') + '(' + f.years.replace(/^Before/, 'before') + ')';
      if (bit && groups[f.brand].indexOf(bit) < 0) groups[f.brand].push(bit);
    });
    var lines = order.map(function (b) { return { brand: b, bits: groups[b] }; });
    return { lines: lines, universal: universal };
  }

  function fitText(p) {
    var s = fitSummary(p);
    if (!s.lines.length) return s.universal ? 'Universal fit' : '';
    var first = s.lines[0];
    var t = 'Fits ' + first.brand + (first.bits.length ? ' ' + first.bits.slice(0, 2).join(', ') : '');
    var extra = Math.max(0, first.bits.length - 2);
    var others = s.lines.slice(1).map(function (l) { return l.brand; });
    if (!extra && others.length && others.length <= 2) t += (others.length === 1 ? ' and ' : ', ') + others.join(' and ');
    else if (extra + others.length > 0) t += ', plus ' + (extra + others.length) + ' more on the part page';
    if (s.universal) t += ' · universal fit';
    return t;
  }

  /* Maker badge: says who made the part, so it never reads like a tub brand */
  function kindOf(t) { return t && t.pt === 'Swim spa' ? 'swim spas' : 'hot tubs'; }

  function makerText(s) {
    if (/^Genuine /.test(s)) return s;
    return 'Made by ' + String(s).replace(/ brand$/, '');
  }

  /* Maker filter: the three groups, plus a maker's own name (Balboa makes parts for lots of tub brands) */
  function madeMatch(s, made) {
    if (made === 'balboa') return /Balboa/.test(s || '');
    return madeKey(s) === made;
  }

  function madeKey(s) {
    if (/^Genuine/.test(s)) return 'genuine';
    if (s === 'Outdoor Living brand') return 'ol';
    return 'other';
  }

  /* ---------- filter rail (same look as the filters on every other collection: assets/ol-collection-filters.css) ---------- */

  /* Brand filter: who made the part, as a logo tile where the site has the logo */
  function makerName(s) {
    var n = String(s || '').replace(/^Genuine /, '').replace(/ brand$/, '').trim();
    return n || 'Other makers';
  }
  var MAKER_ORDER = ['Jacuzzi', 'Arctic Spas', 'Balboa', 'Outdoor Living', 'Superior Wellness', 'Artesian', 'LX Whirlpool'];
  function makerRank(n) { var i = MAKER_ORDER.indexOf(n); return i < 0 ? (n === 'Other makers' ? 99 : 50) : i; }
  var SVG_SLIDERS = '<svg aria-hidden="true" focusable="false" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><line x1="4" y1="7" x2="20" y2="7"/><line x1="4" y1="17" x2="20" y2="17"/><circle cx="9" cy="7" r="2.4" fill="#fff"/><circle cx="15" cy="17" r="2.4" fill="#fff"/></svg>';
  var SVG_CLOSE = '<svg aria-hidden="true" focusable="false" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"><path d="M6 18 18 6M6 6l12 12"/></svg>';
  var SVG_CHEV = '<svg class="ocf-group__chev" aria-hidden="true" focusable="false" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="6 9 12 15 18 9"/></svg>';
  var SVG_X = '<svg aria-hidden="true" focusable="false" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"><path d="M6 18 18 6M6 6l12 12"/></svg>';
  var BINS = 12;
  var MOBILE = window.matchMedia ? window.matchMedia('(max-width: 991px)') : { matches: false };
  function whole(n) { return Math.round(Number(n) || 0); }
  function pounds(n) { return '£' + whole(n).toLocaleString('en-GB'); }
  function listParam(q, name) { return (q.get(name) || '').split(',').filter(Boolean); }

  /* ---------- hub ---------- */

  function Hub(root) {
    this.root = root;
    this.base = root.getAttribute('data-base') || location.pathname;
    this.kind = root.getAttribute('data-kind') || 'hub';
    this.coll = root.getAttribute('data-coll') || HUB_HANDLE;
    this.pageType = null;
    var pts = root.getAttribute('data-type');
    if (pts) Object.keys(TYPE_META).forEach(function (k) { if (TYPE_META[k].slug === pts) this.pageType = k; }, this);
    this.allParts = D.parts.slice();
    this.shown = PAGE;
    var q = new URLSearchParams(location.search);
    this.state = {
      pt: q.get('pt') === 'swim-spa' ? 'Swim spa' : q.get('pt') === 'hot-tub' ? 'Hot tub' : null,
      brand: null, range: null, year: null,
      tt: [], q: q.get('q') || '', made: '', sort: q.get('sort') || 'best',
      lo: q.get('price_min') ? +q.get('price_min') : null, hi: q.get('price_max') ? +q.get('price_max') : null,
      mk: [], av: listParam(q, 'avail').filter(function (x) { return x === 'in' || x === 'out'; }), fo: q.get('fit') === '1'
    };
    if (q.get('stock') === '1' && this.state.av.indexOf('in') < 0) this.state.av.push('in');
    var self = this;
    var b = q.get('brand');
    if (b) brandOrder(null).forEach(function (o) { if (slug(o.brand) === b) self.state.brand = o.brand; });
    var r = q.get('range');
    if (r && this.state.brand) rangesFor(null, this.state.brand).forEach(function (x) { if (slug(x.range) === r) { self.state.range = x.range; if (!self.state.pt) self.state.pt = x.product_type; } });
    var y = q.get('year');
    if (y && this.state.range) {
      var rr = this.rangeObj();
      (rr && rr.years || []).forEach(function (x) { if (slug(x) === y) self.state.year = x; });
    }
    this.presetMade = root.getAttribute('data-made') || '';
    if (this.presetMade) this.state.made = this.presetMade;
    var mks = listParam(q, 'maker');
    if (q.get('made') === 'balboa' && !this.presetMade) mks.push('balboa');
    var mkSeen = {};
    D.parts.forEach(function (p) { var n = makerName(p.s); if (!mkSeen[n] && mks.indexOf(slug(n)) > -1) { mkSeen[n] = 1; self.state.mk.push(n); } });
    var ts = listParam(q, 'type');
    if (ts.length && this.kind !== 'type') Object.keys(TYPE_META).forEach(function (k) { if (ts.indexOf(TYPE_META[k].slug) > -1) self.state.tt.push(k); });
    this.usingSaved = false;
    this.usingPreset = false;
    if (!b) {
      var saved = store(true);
      if (saved && saved.brand) {
        this.state.pt = saved.pt || null; this.state.brand = saved.brand; this.state.range = saved.range || null; this.state.year = saved.year || null;
        this.usingSaved = true;
      } else {
        /* brand pages start with their tub brand filled in; fit bands stay quiet until the shopper picks their own tub */
        var pre = (root.getAttribute('data-tub') || '').split('|');
        if (pre[0] || pre[1]) {
          this.state.pt = pre[0] || null; this.state.brand = pre[1] || null; this.state.range = pre[2] || null;
          this.usingPreset = true;
        }
      }
    }
    function jump() {
      if (!location.hash) return;
      var target = document.getElementById(location.hash.slice(1));
      if (target) setTimeout(function () { jumpTo(target, false); }, 60);
    }
    /* The main parts page draws straight away (as it always has) and adds any new parts once the store answers.
       Every other parts page waits for its own list, keeping the plain list on screen until then. */
    if (this.kind === 'hub') { this.render(); jump(); }
    loadCollection(this.coll, function (products) {
      if (!products) return;
      var known = {};
      self.allParts.forEach(function (p) { known[p.h] = p; });
      var extras = [];
      var inColl = {};
      var changed = false;
      products.forEach(function (pr) {
        inColl[pr.handle] = 1;
        var k = known[pr.handle];
        if (!k) { extras.push(partFromProduct(pr, self.pageType)); return; }
        /* live price, offer price and stock from the store, so a card never shows an old price */
        var live = partFromProduct(pr, self.pageType);
        /* a part we had no fit for picks up its "Fits ..." tags once they are added */
        if (!k.f.length && live.f.length) { k.f = live.f; changed = true; }
        if (k.price !== live.price || k.compare !== live.compare || k.avail !== live.avail) changed = true;
        k.price = live.price; k.compare = live.compare; k.avail = live.avail;
        if (!k.img && live.img) k.img = live.img;
      });
      if (self.kind === 'hub') {
        if (!extras.length && !changed) return;
        D.parts = self.allParts.concat(extras);
        self.render();
        return;
      }
      D.parts = self.allParts.filter(function (p) { return inColl[p.h]; }).concat(extras);
      self.render();
      jump();
    });
  }

  Hub.prototype.rangeObj = function () {
    var s = this.state;
    var hit = null;
    rangesFor(s.pt, s.brand).forEach(function (r) { if (r.range === s.range) hit = r; });
    return hit;
  };

  Hub.prototype.tub = function () {
    var s = this.state;
    return s.brand ? { pt: s.pt, brand: s.brand, range: s.range, year: s.year } : null;
  };

  Hub.prototype.sync = function () {
    var s = this.state;
    var q = new URLSearchParams();
    var keep = new URLSearchParams(location.search);
    if (keep.get('view')) q.set('view', keep.get('view'));
    if (keep.get('preview_theme_id')) q.set('preview_theme_id', keep.get('preview_theme_id'));
    if (s.pt) q.set('pt', slug(s.pt));
    var own = !this.usingSaved && !this.usingPreset;
    if (s.pt && this.usingPreset) q.delete('pt');
    if (s.brand && own) q.set('brand', slug(s.brand));
    if (s.range && own) q.set('range', slug(s.range));
    if (s.year && own) q.set('year', slug(s.year));
    if (s.tt.length) q.set('type', s.tt.map(function (t) { return TYPE_META[t].slug; }).join(','));
    if (s.q) q.set('q', s.q);
    if (s.lo !== null) q.set('price_min', whole(s.lo));
    if (s.hi !== null) q.set('price_max', whole(s.hi));
    if (s.mk.length) q.set('maker', s.mk.map(slug).join(','));
    if (s.av.length) q.set('avail', s.av.join(','));
    if (s.fo && this.tub()) q.set('fit', '1');
    if (s.sort && s.sort !== 'best') q.set('sort', s.sort);
    history.replaceState(null, '', location.pathname + '?' + q.toString());
  };

  Hub.prototype.set = function (patch, keepEditing) {
    for (var k in patch) this.state[k] = patch[k];
    if ('brand' in patch || 'range' in patch || 'year' in patch || 'pt' in patch) { this.usingSaved = false; this.usingPreset = false; }
    this.shown = PAGE; this.shownBy = {}; this.openFold = null;
    if (keepEditing !== undefined) this.editing = keepEditing;
    this.sync();
    this.render();
  };

  Hub.prototype.results = function () {
    var s = this.state;
    var tub = this.tub();
    var q = norm(s.q);
    var g = { fit: [], brand: [], universal: [], other: [], any: [] };
    var self = this;
    D.parts.forEach(function (p) {
      if (!self.keep(p, null)) return;
      var lvl = fitLevel(p, tub) || 'other';
      g[lvl].push({ p: p, lvl: lvl });
    });
    var sorter = {
      best: function (a, b) { return (b.p.avail - a.p.avail) || (typeRank(a.p.pt) - typeRank(b.p.pt)) || (b.p.price - a.p.price); },
      low: function (a, b) { return a.p.price - b.p.price; },
      high: function (a, b) { return b.p.price - a.p.price; },
      name: function (a, b) { return a.p.t.localeCompare(b.p.t); }
    }[s.sort] || function () { return 0; };
    Object.keys(g).forEach(function (k) { g[k].sort(sorter); });
    g.matched = g.fit.length + g.brand.length + g.universal.length;
    g.total = g.matched + g.other.length + g.any.length;
    return g;
  };

  /* One test for every filter. "skip" leaves one group out, so each option's count shows what ticking it would give. */
  Hub.prototype.keep = function (p, skip) {
    var s = this.state;
    if (s.made && !madeMatch(p.s, s.made)) return false;
    if (skip !== 'type' && s.tt.length && s.tt.indexOf(p.pt) < 0) return false;
    if (skip !== 'maker' && s.mk.length && s.mk.indexOf(makerName(p.s)) < 0) return false;
    if (skip !== 'avail' && s.av.length === 1 && (s.av[0] === 'in') !== !!p.avail) return false;
    if (skip !== 'price') {
      if (s.lo !== null && p.price < s.lo) return false;
      if (s.hi !== null && p.price > s.hi + 0.999) return false;
    }
    if (skip !== 'fit' && s.fo) { var tub = this.tub(); if (tub && fitLevel(p, tub) !== 'fit') return false; }
    var q = norm(s.q);
    if (q) {
      var hay = norm(p.t + ' ' + p.old + ' ' + (p.n || ''));
      var words = q.split(' ');
      for (var i = 0; i < words.length; i++) if (hay.indexOf(words[i]) < 0) return false;
    }
    return true;
  };

  /* Type chips count every part of that type: choosing a tub never hides parts. */
  Hub.prototype.typeCounts = function () {
    var c = {};
    D.parts.forEach(function (p) { c[p.pt] = (c[p.pt] || 0) + 1; });
    return c;
  };

  /* Optional tub filter: a row of dropdowns. Each one only appears once it is useful. */
  Hub.prototype.renderTubBar = function () {
    var self = this;
    var s = this.state;
    var ranges = s.brand ? rangesFor(s.pt, s.brand) : [];
    var robj = this.rangeObj();
    var years = robj && robj.years ? robj.years.filter(function (y) { return yearRange(y); }) : [];
    if (years.length < 2) years = [];

    function field(label, id, select) {
      return el('div', { class: 'olp-tub__f' }, [el('label', { class: 'olp-tub__l', for: id, text: label }), select]);
    }
    function sel(id, value, opts, onchange) {
      return el('select', { id: id, class: 'olp-select', onchange: function (e) { onchange(e.target.value); } }, opts.map(function (o) {
        return el('option', { value: o[0], selected: o[0] === value ? 'selected' : null, text: o[1] });
      }));
    }

    var ptSel = sel('olp-t-pt', s.pt || '', [['', 'Any type'], ['Hot tub', 'Hot tub'], ['Swim spa', 'Swim spa']], function (v) {
      var keep = s.brand && rangesFor(v || null, s.brand).length ? s.brand : null;
      var t = keep ? tubForBrand(v || null, keep) : {};
      self.set({ pt: v || null, brand: keep, range: t.range || null, year: null });
    });
    var brandOpts = [['', 'Any brand']].concat(brandOrder(s.pt).map(function (b) { return [b.brand, b.brand]; }));
    var brandSel = sel('olp-t-brand', s.brand || '', brandOpts, function (v) {
      var t = v ? tubForBrand(s.pt, v) : {};
      self.set({ brand: v || null, range: t.range || null, year: null });
    });
    var fields = [field('Type', 'olp-t-pt', ptSel), field('Brand', 'olp-t-brand', brandSel)];
    if (s.brand && ranges.length > 1) {
      var rSel = el('select', { id: 'olp-t-range', class: 'olp-select', onchange: function (e) { self.set({ range: e.target.value || null, year: null }); } },
        [el('option', { value: '', text: 'Not sure, any model' })]);
      var groups = {}, order = [];
      ranges.forEach(function (r) {
        var label = r.range.indexOf(r.brand) === 0 ? r.range.slice(r.brand.length).trim() || r.range : r.range;
        label = label.charAt(0).toUpperCase() + label.slice(1).replace(' (earlier model)', '');
        if (!r.group && (r.models || []).length) label += ' (' + r.models.slice(0, 3).join(', ').replace(/J-(\d)/g, 'J$1') + (r.models.length > 3 ? '…' : '') + ')';
        var o = el('option', { value: r.range, selected: s.range === r.range ? 'selected' : null, text: label });
        if (r.group) {
          if (!groups[r.group]) { groups[r.group] = el('optgroup', { label: r.group }); order.push(r.group); rSel.appendChild(groups[r.group]); }
          groups[r.group].appendChild(o);
        } else rSel.appendChild(o);
      });
      fields.push(field(s.brand === 'Outdoor Living' ? 'Model' : 'Range or model', 'olp-t-range', rSel));
    }
    if (s.range && years.length) {
      fields.push(field('Year made', 'olp-t-year', sel('olp-t-year', s.year || '', [['', 'Not sure']].concat(years.map(function (y) { return [y, y]; })), function (v) { self.set({ year: v || null }); })));
    }

    var saved = store(true);
    var isSaved = saved && saved.brand === s.brand && saved.range === s.range && saved.year === s.year && saved.pt === s.pt;
    return el('section', { class: 'olp-tub' + (s.brand ? ' olp-tub--on' : ''), 'aria-labelledby': 'olp-pick-h' }, [
      el('div', { class: 'olp-tub__head' }, [
        el('h2', { class: 'olp-tub__h', id: 'olp-pick-h', text: s.brand ? 'Your tub' : 'Add your tub (optional)' }),
        el('p', { class: 'olp-tub__sub', text: s.brand ? 'Parts made for it come first. Everything else is still listed below.' : this.presetMade === 'balboa' ? 'Balboa makes the controls, heaters and ozone parts inside lots of hot tub brands. Add your brand to check the fit.' : 'We put the parts made for it first. Nothing is hidden.' })
      ]),
      el('div', { class: 'olp-tub__row' }, fields.concat([
        s.brand ? el('button', { type: 'button', class: 'olp-btn olp-btn--plain olp-tub__clear', onclick: function () { self.set({ pt: null, brand: null, range: null, year: null }); } }, ['Clear']) : null
      ])),
      el('p', { class: 'olp-tub__help' }, ["Can't see your tub? Lots of our parts are universal, so browse below or call ", el('a', { href: TEL, text: PHONE }), ' and we will find the right one.']),
      s.brand ? el('label', { class: 'olp-remember' }, [
        el('input', { type: 'checkbox', checked: isSaved ? 'checked' : null, onchange: function (e) {
          if (e.target.checked) store(false, { pt: s.pt, brand: s.brand, range: s.range, year: s.year }); else store(false, null);
          self.render();
        } }),
        el('span', { text: 'Remember my tub on parts, filters and covers pages' })
      ]) : null
    ]);
  };

  Hub.prototype.renderTypes = function () {
    var self = this;
    var s = this.state;
    var tub = this.tub();
    var onType = this.kind === 'type';
    /* On a part type page the tiles are links to the other part pages, counted across every part.
       Everywhere else they filter this page, and still carry a link to the part's own page. */
    var counts = {};
    (onType ? this.allParts : D.parts).forEach(function (p) { counts[p.pt] = (counts[p.pt] || 0) + 1; });
    var all = (onType ? this.allParts : D.parts).length;
    var nav = el('nav', { class: 'olp-types', id: 'olp-types', 'aria-label': 'Part types' }, [
      el('h2', { class: 'olp-types__h', text: onType ? 'Looking for a different part?' : 'What part do you need?' })
    ]);
    var row = el('div', { class: 'olp-types__row' });
    function tile(key, label, iconId, n, pressed, href, onPick) {
      return el('a', {
        class: 'olp-type', href: href, role: onType ? null : 'button', 'aria-pressed': onType ? null : String(pressed),
        'aria-current': onType && pressed ? 'page' : null,
        onclick: onPick ? function (e) { if (e.metaKey || e.ctrlKey || e.shiftKey || e.button) return; e.preventDefault(); onPick(); } : null
      }, [icon(iconId, 36, 24), el('span', { class: 'olp-type__n', text: label }), el('span', { class: 'olp-type__c', text: String(n) })]);
    }
    if (onType) row.appendChild(tile(null, 'All parts', 'oli-filter-parts', all, false, pageUrl(HUB_HANDLE, tub), null));
    else row.appendChild(tile(null, 'All parts', 'oli-filter-parts', all, !s.tt.length, location.pathname + location.search, function () { self.apply({ tt: [] }); }));
    (D.types || Object.keys(TYPE_META)).forEach(function (t) {
      var m = TYPE_META[t];
      if (!m) return;
      var n = counts[t] || 0;
      if (!n) return;
      if (onType) row.appendChild(tile(t, m.short, m.icon, self.pageType === t ? D.parts.length : n, self.pageType === t, typeUrl(t, tub), null));
      else row.appendChild(tile(t, m.short, m.icon, n, s.tt.length === 1 && s.tt[0] === t, typeUrl(t, tub), function () { self.apply({ tt: s.tt.length === 1 && s.tt[0] === t ? [] : [t] }); }));
    });
    nav.appendChild(row);
    return nav;
  };

  Hub.prototype.card = function (r) {
    var p = r.p;
    var tub = this.tub();
    var img = p.img ? p.img + (p.img.indexOf('?') > -1 ? '&' : '?') + 'width=360' : null;
    var made = madeKey(p.s);
    var yes = tub && r.lvl === 'fit' && !this.usingPreset;
    var fit, fitCls = '';
    fit = fitText(p);
    if (yes && !fit) fit = 'Fits ' + tub.brand + ' ' + kindOf(tub);
    return el('li', { class: 'olp-cards__item' }, [
      el('a', { class: 'olp-card' + (yes ? ' olp-card--fit' : '') + (p.avail ? '' : ' olp-card--out'), href: '/products/' + p.h }, [
        yes ? el('span', { class: 'olp-card__match', title: 'Fits your ' + tubLabel(tub) }, [el('span', { class: 'olp-card__tick', 'aria-hidden': 'true' }), 'Fits your tub']) : null,
        el('span', { class: 'olp-card__img' }, [img ? el('img', { src: img, alt: '', loading: 'lazy', decoding: 'async', width: '360', height: '360' }) : el('span', { class: 'olp-card__noimg' }, [icon((TYPE_META[p.pt] || {}).icon || 'oli-filter-parts', 60, 40)])]),
        p.s ? el('span', { class: 'olp-card__badge olp-card__badge--' + made, text: makerText(p.s) }) : null,
        el('span', { class: 'olp-card__t', text: p.t }),
        fit ? el('span', { class: 'olp-card__fit' + fitCls, text: fit }) : null,
        el('span', { class: 'olp-card__foot' }, [
          el('span', { class: 'olp-card__price' }, [money(p.price), p.compare && p.compare > p.price ? el('s', { text: money(p.compare) }) : null]),
          el('span', { class: 'olp-card__stock', text: p.avail ? 'In stock' : 'Out of stock' })
        ])
      ])
    ]);
  };

  Hub.prototype.renderGrid = function () {
    var self = this;
    var s = this.state;
    var res = this.results();
    var wrap = el('section', { class: 'olp-results', id: 'olp-grid', 'aria-label': 'Parts' });

    /* Toolbar, as on every other collection: count, Filters button (phones and tablets) and sort */
    var openBtn = el('button', { type: 'button', class: 'ocf-open', 'data-ocf-open': '', 'aria-expanded': 'false', 'aria-controls': 'ocf-form', onclick: function () { self.openSheet(); } }, [
      el('span', { html: SVG_SLIDERS, style: 'display:contents' }), el('span', { text: 'Filters' }), el('span', { class: 'ocf-open__n', hidden: true })
    ]);
    var sortSel = el('select', { id: 'ocf-sort', class: 'ocf-sort__select', onchange: function (e) { self.apply({ sort: e.target.value }); } }, [
      ['best', 'Recommended'], ['low', 'Price, low to high'], ['high', 'Price, high to low'], ['name', 'Name, A to Z']
    ].map(function (o) { return el('option', { value: o[0], selected: s.sort === o[0] ? 'selected' : null, text: o[1] }); }));
    var bar = el('div', { class: 'ocf-toolbar olp-toolbar' }, [
      el('p', { class: 'ocf-count', role: 'status' }, [el('strong', { text: String(res.total) }), ' parts']),
      openBtn,
      el('div', { class: 'ocf-sort' }, [el('label', { class: 'ocf-sort__label', for: 'ocf-sort', text: 'Sort by' }), sortSel])
    ]);
    this.openBtn = openBtn;
    this.toolCount = bar.querySelector('.ocf-count');

    var railCol = el('div', { class: 'o-layout__item u-1/1 u-1/4@desk ocf-col olp-railcol' });
    this.railCol = railCol;
    railCol.appendChild(this.renderRail(res));

    var heading = s.tt.length === 1 ? TYPE_META[s.tt[0]].short : this.kind === 'type' && this.pageType ? TYPE_META[this.pageType].short : 'Parts';
    var head = el('div', { class: 'olp-bar' }, [
      el('div', { class: 'olp-bar__count', 'aria-live': 'polite' }, [el('strong', { text: String(res.total) }), ' ' + heading.charAt(0).toLowerCase() + heading.slice(1), el('span', { class: 'olp-bar__match' })]),
      el('div', { class: 'olp-bar__tools' }, [
        el('label', { class: 'olp-search' }, [
          el('span', { class: 'olp-vh', text: 'Search parts' }),
          el('input', {
            type: 'search', value: s.q, placeholder: 'Search by name or part number', autocomplete: 'off',
            oninput: function (e) { clearTimeout(self.t); var v = e.target.value; self.t = setTimeout(function () { self.state.q = v; self.shown = PAGE; self.shownBy = {}; self.sync(); self.refresh(); }, 200); }
          })
        ])
      ])
    ]);
    var list = el('div', { class: 'olp-results__list' });
    var listCol = el('div', { class: 'o-layout__item u-1/1 u-3/4@desk olp-listcol' }, [head, list]);
    wrap.appendChild(bar);
    wrap.appendChild(el('div', { class: 'collection-products olp-layout' }, [el('div', { class: 'o-layout' }, [railCol, listCol])]));
    this.listEl = list;
    this.countEl = head.querySelector('.olp-bar__count strong');
    this.matchEl = head.querySelector('.olp-bar__match');
    this.fillList(res);
    return wrap;
  };

  /* Filter changes redraw the part tiles, the rail and the list in place, so the rail keeps its scroll and the phone sheet stays open */
  Hub.prototype.apply = function (patch) {
    for (var k in patch) this.state[k] = patch[k];
    this.shown = PAGE; this.shownBy = {}; this.openFold = null;
    this.sync();
    this.refresh();
  };

  Hub.prototype.clearFilters = function () {
    this.apply({ tt: [], mk: [], av: [], lo: null, hi: null, fo: false, q: '' });
    var box = this.root.querySelector('.olp-search input');
    if (box) box.value = '';
  };

  Hub.prototype.activeCount = function () {
    var s = this.state;
    return s.tt.length + s.mk.length + (s.av.length === 1 ? 1 : 0) + (s.lo !== null || s.hi !== null ? 1 : 0) + (s.fo && this.tub() ? 1 : 0);
  };

  Hub.prototype.refresh = function () {
    var res = this.results();
    var types = this.root.querySelector('#olp-types');
    if (types) types.parentNode.replaceChild(this.renderTypes(), types);
    if (this.railCol) {
      var old = this.railCol.querySelector('.ocf');
      var scroller = old && old.querySelector('.ocf__scroll');
      var top = scroller ? scroller.scrollTop : 0;
      var wasOpen = old && old.getAttribute('data-open') === 'true';
      var focusId = document.activeElement && this.railCol.contains(document.activeElement) ? document.activeElement.id : null;
      var next = this.renderRail(res);
      if (wasOpen) { next.setAttribute('data-open', 'true'); next.setAttribute('role', 'dialog'); next.setAttribute('aria-modal', 'true'); }
      this.railCol.replaceChild(next, old);
      var sc = next.querySelector('.ocf__scroll');
      if (sc) sc.scrollTop = top;
      if (focusId) { var f = document.getElementById(focusId); if (f) f.focus({ preventScroll: true }); }
    }
    if (this.toolCount) this.toolCount.firstChild.textContent = String(res.total);
    var n = this.activeCount();
    var badge = this.openBtn && this.openBtn.querySelector('.ocf-open__n');
    if (badge) { badge.textContent = String(n); badge.hidden = !n; }
    var heading = this.state.tt.length === 1 ? TYPE_META[this.state.tt[0]].short : this.kind === 'type' && this.pageType ? TYPE_META[this.pageType].short : 'Parts';
    var countBox = this.root.querySelector('.olp-bar__count');
    if (countBox && countBox.childNodes[1]) countBox.childNodes[1].textContent = ' ' + heading.charAt(0).toLowerCase() + heading.slice(1);
    this.fillList(res);
  };

  Hub.prototype.openSheet = function () {
    if (!MOBILE.matches) return;
    var form = this.railCol && this.railCol.querySelector('.ocf');
    if (!form) return;
    this.lastFocus = document.activeElement;
    form.setAttribute('data-open', 'true'); form.setAttribute('role', 'dialog'); form.setAttribute('aria-modal', 'true');
    document.documentElement.classList.add('ocf-lock');
    if (this.openBtn) this.openBtn.setAttribute('aria-expanded', 'true');
    var c = form.querySelector('.ocf__close'); if (c) c.focus();
  };

  Hub.prototype.closeSheet = function () {
    var form = this.railCol && this.railCol.querySelector('.ocf');
    if (!form || form.getAttribute('data-open') !== 'true') return;
    form.removeAttribute('data-open'); form.setAttribute('role', 'search'); form.removeAttribute('aria-modal');
    document.documentElement.classList.remove('ocf-lock');
    if (this.openBtn) { this.openBtn.setAttribute('aria-expanded', 'false'); this.openBtn.focus(); }
    var grid = document.getElementById('olp-grid');
    if (grid) { var r = grid.getBoundingClientRect(); var off = headerOffset(); if (r.top < off) window.scrollTo({ top: window.pageYOffset + r.top - off }); }
  };

  /* The rail: price, brand (who made it), part type (main parts page), fits my tub, availability. Every group open, options that would show nothing are left out. */
  Hub.prototype.renderRail = function (res) {
    var self = this;
    var s = this.state;
    var tub = this.tub();
    var uid = 0;
    function id() { uid++; return 'ocf-p-' + uid; }
    function count(skip, test) { var n = 0; D.parts.forEach(function (p) { if (test(p) && self.keep(p, skip)) n++; }); return n; }
    function group(kind, name, now, body) {
      return el('details', { class: 'ocf-group ocf-group--' + kind, 'data-ocf-group': '', open: true }, [
        el('summary', { class: 'ocf-group__head' }, [el('span', { class: 'ocf-group__name', text: name }), el('span', { class: 'ocf-group__now', text: now || '' }), el('span', { html: SVG_CHEV, style: 'display:contents' })]),
        el('div', { class: 'ocf-group__body' }, body)
      ]);
    }
    function pill(label, n, on, onchange, iconId) {
      var i = id();
      return el('label', { class: 'ocf-pill' + (iconId ? ' ocf-pill--icon' : ''), for: i }, [
        el('input', { class: 'ocf-input', type: 'checkbox', id: i, checked: on ? 'checked' : null, onchange: function (e) { onchange(e.target.checked); } }),
        iconId ? (function () { var ic = icon(iconId, 20, 20); ic.setAttribute('class', 'ocf-pill__icon'); return ic; })() : null,
        el('span', { class: 'ocf-pill__name', text: label }),
        el('span', { class: 'ocf-pill__count', text: String(n) })
      ]);
    }
    function toggle(list, v, on) { var out = list.filter(function (x) { return x !== v; }); if (on) out.push(v); return out; }

    var groups = [];
    var chips = [];

    /* Price: real lowest and highest on this page, bar chart with two handles, and From / To boxes */
    var prices = D.parts.filter(function (p) { return self.keep(p, 'price'); }).map(function (p) { return p.price; });
    var all = D.parts.map(function (p) { return p.price; }).filter(function (v) { return v > 0; });
    var lowest = Math.floor(Math.min.apply(null, all.length ? all : [0]));
    var highest = Math.ceil(Math.max.apply(null, all.length ? all : [0]));
    if (highest <= lowest) highest = lowest + 1;
    var lo = s.lo !== null ? Math.max(lowest, Math.min(s.lo, highest)) : lowest;
    var hi = s.hi !== null ? Math.max(lowest, Math.min(s.hi, highest)) : highest;
    var span = highest - lowest;
    var bars = el('div', { class: 'ocf-hist__bars', 'aria-hidden': 'true' });
    var counts = []; for (var b = 0; b < BINS; b++) counts.push(0);
    prices.forEach(function (v) { counts[Math.min(BINS - 1, Math.max(0, Math.floor((v - lowest) / span * BINS)))]++; });
    var topN = Math.max.apply(null, counts) || 1;
    counts.forEach(function (c, k) {
      var from = lowest + span * k / BINS, to = lowest + span * (k + 1) / BINS;
      var bar = el('span', { class: 'ocf-hist__bar', style: 'height:' + (c ? Math.max(6, c / topN * 100) : 0) + '%' });
      if (to > lo && from < hi) bar.setAttribute('data-in', '');
      bars.appendChild(bar);
    });
    var fill = el('span', { class: 'ocf-hist__fill' });
    function paint(a, z) {
      fill.style.left = ((a - lowest) / span * 100) + '%';
      fill.style.right = (100 - (z - lowest) / span * 100) + '%';
      [].forEach.call(bars.children, function (bar, k) {
        var from = lowest + span * k / BINS, to = lowest + span * (k + 1) / BINS;
        if (to > a && from < z) bar.setAttribute('data-in', ''); else bar.removeAttribute('data-in');
      });
    }
    var boxLo = el('input', { type: 'text', inputmode: 'numeric', pattern: '[0-9]*', autocomplete: 'off', placeholder: String(lowest), value: String(whole(lo)), 'aria-label': 'Lowest price' });
    var boxHi = el('input', { type: 'text', inputmode: 'numeric', pattern: '[0-9]*', autocomplete: 'off', placeholder: String(highest), value: String(whole(hi)), 'aria-label': 'Highest price' });
    function commit(a, z) {
      a = Math.max(lowest, Math.min(a, highest)); z = Math.max(lowest, Math.min(z, highest));
      if (a > z) { var t = a; a = z; z = t; }
      self.apply({ lo: a <= lowest ? null : a, hi: z >= highest ? null : z });
    }
    var rLo = el('input', { class: 'ocf-rng', type: 'range', min: String(lowest), max: String(highest), step: '1', value: String(lo), 'aria-label': 'Lowest price',
      oninput: function () { if (+rLo.value > +rHi.value) rLo.value = rHi.value; boxLo.value = rLo.value; paint(+rLo.value, +rHi.value); },
      onchange: function () { commit(+rLo.value, +rHi.value); } });
    var rHi = el('input', { class: 'ocf-rng', type: 'range', min: String(lowest), max: String(highest), step: '1', value: String(hi), 'aria-label': 'Highest price',
      oninput: function () { if (+rHi.value < +rLo.value) rHi.value = rLo.value; boxHi.value = rHi.value; paint(+rLo.value, +rHi.value); },
      onchange: function () { commit(+rLo.value, +rHi.value); } });
    function typed() {
      var a = boxLo.value.replace(/[^0-9]/g, ''), z = boxHi.value.replace(/[^0-9]/g, '');
      commit(a === '' ? lowest : +a, z === '' ? highest : +z);
    }
    [boxLo, boxHi].forEach(function (bx) {
      bx.addEventListener('change', typed);
      bx.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); typed(); } });
    });
    var hist = el('div', { class: 'ocf-hist', 'data-ocf-ready': '' }, [bars, el('div', { class: 'ocf-hist__rail', 'aria-hidden': 'true' }, [fill]), rLo, rHi]);
    paint(lo, hi);
    var priceNow = s.lo !== null || s.hi !== null ? pounds(lo) + ' to ' + pounds(hi) : '';
    if (priceNow) chips.push([priceNow, function () { self.apply({ lo: null, hi: null }); }]);
    groups.push(group('price', 'Price', priceNow, [el('div', { class: 'ocf-price' }, [
      hist,
      el('div', { class: 'ocf-price__boxes' }, [
        el('label', { class: 'ocf-price__field' }, [el('span', { class: 'ocf-price__name', text: 'From' }), el('span', { class: 'ocf-price__box' }, [el('span', { class: 'ocf-price__sym', 'aria-hidden': 'true', text: '£' }), boxLo])]),
        el('label', { class: 'ocf-price__field' }, [el('span', { class: 'ocf-price__name', text: 'To' }), el('span', { class: 'ocf-price__box' }, [el('span', { class: 'ocf-price__sym', 'aria-hidden': 'true', text: '£' }), boxHi])])
      ])
    ])]));

    /* Brand: who made the part, logo tiles where the site has the logo */
    var makers = {};
    D.parts.forEach(function (p) { if (!s.made || madeMatch(p.s, s.made)) makers[makerName(p.s)] = 1; });
    var names = Object.keys(makers).sort(function (a, b) { return (makerRank(a) - makerRank(b)) || a.localeCompare(b); });
    if (names.length > 1) {
      var tiles = el('ul', { class: 'ocf-tiles' });
      names.forEach(function (nm) {
        var on = s.mk.indexOf(nm) > -1;
        var n = count('maker', function (p) { return makerName(p.s) === nm; });
        if (!n && !on) return;
        var i = id();
        var logo = BRAND_LOGOS[nm];
        tiles.appendChild(el('li', { class: 'ocf-tiles__item' }, [el('label', { class: 'ocf-tile', for: i }, [
          el('input', { class: 'ocf-input', type: 'checkbox', id: i, checked: on ? 'checked' : null, onchange: function (e) { self.apply({ mk: toggle(s.mk, nm, e.target.checked) }); } }),
          el('span', { class: 'ocf-tile__face' }, [logo ? el('img', { class: 'ocf-tile__logo', src: logo, alt: nm, width: '130', height: '36', loading: 'eager', decoding: 'async' }) : el('span', { class: 'ocf-tile__name', text: nm })]),
          el('span', { class: 'ocf-tile__count', text: String(n) })
        ])]));
        if (on) chips.push([nm, function () { self.apply({ mk: toggle(s.mk, nm, false) }); }]);
      });
      groups.push(group('brand', 'Brand', s.mk.join(', '), [tiles]));
    }

    /* Part type: only on the main parts page (a part type page is already one type) */
    if (this.kind !== 'type') {
      var have = {};
      D.parts.forEach(function (p) { have[p.pt] = 1; });
      var pills = el('div', { class: 'ocf-pills' });
      (D.types || TYPE_ORDER).forEach(function (t) {
        var m = TYPE_META[t];
        if (!m || !have[t]) return;
        var on = s.tt.indexOf(t) > -1;
        var n = count('type', function (p) { return p.pt === t; });
        if (!n && !on) return;
        pills.appendChild(pill(m.short, n, on, function (v) { self.apply({ tt: toggle(s.tt, t, v) }); }, m.icon));
        if (on) chips.push([m.short, function () { self.apply({ tt: toggle(s.tt, t, false) }); }]);
      });
      if (pills.children.length > 1) groups.push(group('chips', 'Part type', s.tt.map(function (t) { return TYPE_META[t].short; }).join(', '), [pills]));
    }

    /* Fits my tub: works with the tub picker above the parts */
    var fitBody;
    if (tub && !this.usingPreset) {
      var nFit = count('fit', function (p) { return fitLevel(p, tub) === 'fit'; });
      fitBody = [nFit || s.fo ? el('div', { class: 'ocf-pills' }, [pill('Only parts for my ' + tubLabel(tub), nFit, s.fo, function (v) { self.apply({ fo: v }); })])
        : el('p', { class: 'ocf-hint', style: 'margin-top:0' }, ['None of these parts are linked to your ' + tubLabel(tub) + ' yet, so everything is still shown. Call ', el('a', { href: TEL, text: PHONE }), ' and we will tell you which suit it.']),
        el('p', { class: 'ocf-hint' }, ['Change your tub in the box above the parts. ', el('a', { href: '#olp-pick-h', class: 'olp-railtub', onclick: function (e) { e.preventDefault(); self.closeSheet(); var t = document.getElementById('olp-pick-h'); if (t) jumpTo(t, true); } }, ['Change tub'])])];
      if (s.fo) chips.push(['Fits my ' + tubLabel(tub), function () { self.apply({ fo: false }); }]);
    } else {
      fitBody = [el('p', { class: 'ocf-hint', style: 'margin-top:0' }, ['Add your tub and the parts made for it come first. ']),
        el('button', { type: 'button', class: 'olp-btn olp-btn--line olp-railtub', onclick: function () { self.closeSheet(); var t = document.getElementById('olp-pick-h'); if (t) { jumpTo(t, true); var f = document.getElementById('olp-t-brand'); if (f) setTimeout(function () { f.focus({ preventScroll: true }); }, 400); } } }, ['Add your tub'])];
    }
    groups.push(group('fit', 'Fits my tub', tub && s.fo ? 'Yes' : '', fitBody));

    /* Availability */
    var nIn = count('avail', function (p) { return p.avail; }), nOut = count('avail', function (p) { return !p.avail; });
    var avPills = el('div', { class: 'ocf-pills' });
    [['in', 'In stock', nIn], ['out', 'Out of stock', nOut]].forEach(function (a) {
      var on = s.av.indexOf(a[0]) > -1;
      if (!a[2] && !on) return;
      avPills.appendChild(pill(a[1], a[2], on, function (v) { self.apply({ av: toggle(s.av, a[0], v) }); }));
      if (on) chips.push([a[1], function () { self.apply({ av: toggle(s.av, a[0], false) }); }]);
    });
    groups.push(group('avail', 'Availability', s.av.length === 1 ? (s.av[0] === 'in' ? 'In stock' : 'Out of stock') : '', [avPills]));

    var chipBox = el('div', { class: 'ocf-chips', hidden: !chips.length }, chips.map(function (c) {
      return el('a', { class: 'ocf-chip', href: '#', onclick: function (e) { e.preventDefault(); c[1](); } }, [c[0], el('span', { html: SVG_X, style: 'display:contents' })]);
    }));
    var total = res.total;
    var form = el('form', { id: 'ocf-form', class: 'ocf', role: 'search', 'aria-label': 'Filter parts', onsubmit: function (e) { e.preventDefault(); self.closeSheet(); },
      onkeydown: function (e) { if (e.key === 'Escape') self.closeSheet(); } }, [
      el('div', { class: 'ocf__head' }, [
        el('div', { class: 'ocf__top' }, [
          el('h2', { class: 'ocf__title', text: 'Filters' }),
          el('a', { class: 'ocf__clear', href: '#', hidden: !this.activeCount() && !s.q, onclick: function (e) { e.preventDefault(); self.clearFilters(); } }, ['Clear all']),
          el('button', { type: 'button', class: 'ocf__close', 'aria-label': 'Close filters', html: SVG_CLOSE, onclick: function () { self.closeSheet(); } })
        ]),
        el('p', { class: 'ocf-hero' }, [el('strong', { text: String(total) }), el('span', { text: total === 1 ? 'part' : 'parts' })])
      ]),
      el('div', { class: 'ocf__scroll' }, [chipBox].concat(groups)),
      el('div', { class: 'ocf__foot' }, [el('button', { type: 'submit', class: 'ocf-apply' }, [el('span', { text: 'Show ' + total + (total === 1 ? ' part' : ' parts') })])])
    ]);
    return form;
  };

  Hub.prototype.fillList = function (res) {
    var self = this;
    var s = this.state;
    var tub = this.tub();
    var list = this.listEl;
    list.innerHTML = '';
    if (this.countEl) this.countEl.textContent = String(res.total);
    this.shownBy = this.shownBy || {};
    if (this.matchEl) this.matchEl.textContent = '';
    var kind = s.pt === 'Swim spa' ? 'swim spas' : 'hot tubs';

    if (!res.total) {
      list.appendChild(el('div', { class: 'olp-empty' }, [
        el('p', { class: 'olp-empty__h', text: 'No parts match that search and those filters' }),
        el('p', { text: 'Try fewer words or a part number, or call ' + PHONE + ' with a photo of the old part and we will find it for you.' }),
        el('div', { class: 'olp-empty__acts' }, [
          el('button', { type: 'button', class: 'olp-btn olp-btn--line', onclick: function () { self.clearFilters(); } }, ['Clear search and filters']),
          el('a', { class: 'olp-btn olp-btn--plain', href: TEL }, ['Call ' + PHONE])
        ])
      ]));
      return this.help(list);
    }

    var ownType = s.tt.length === 1 ? s.tt[0] : (this.kind === 'type' ? this.pageType : null);
    var what = ownType ? TYPE_META[ownType].short.replace(/^./, function (c) { return c.toLowerCase(); }) : 'parts';
    function noun(n) { return n === 1 ? (ownType ? what.replace(/s$/, '') : 'part') : what; }
    var label = tub ? tubLabel(tub) : '';

    /* one grid of cards, shown a page at a time */
    /* Cards below the "that is all" line come in whole sets of 12, so rows are always full at 4, 3 or 2 across */
    function snap(x, nTop) {
      if (!nTop || x <= nTop) return x;
      return nTop + Math.ceil((x - nTop) / 12) * 12;
    }
    function grid(key, items, endFit) {
      var nTop = endFit ? endFit.n : 0;
      var shown = Math.min(items.length, snap(self.shownBy[key] || PAGE, nTop));
      var ul = el('ul', { class: 'olp-cards' });
      items.slice(0, shown).forEach(function (r, i) {
        if (endFit && i === endFit.n) ul.appendChild(endFit.row);
        ul.appendChild(self.card(r));
      });
      var more = items.length > shown ? el('div', { class: 'olp-more' }, [
        el('button', { type: 'button', class: 'olp-btn olp-btn--line', onclick: function () { self.shownBy[key] = shown + PAGE; self.fillList(self.results()); } },
          ['Show ' + (Math.min(items.length, snap(shown + PAGE, nTop)) - shown) + ' more of ' + items.length])
      ]) : null;
      return [ul, more];
    }

    if (!tub) {
      list.appendChild(el('section', { class: 'olp-group', 'aria-label': 'Parts' }, grid('any', res.any)));
      return this.help(list);
    }

    /* With a tub: one single grid. Parts listed for the tub come first with a green tick, then every other part. */
    var all = res.fit.concat(res.brand, res.universal, res.other);
    var nFit = this.usingPreset ? 0 : res.fit.length;
    if (this.matchEl) {
      this.matchEl.innerHTML = '';
      if (nFit) this.matchEl.appendChild(el('span', { class: 'olp-bar__pill' }, [el('span', { class: 'olp-card__tick', 'aria-hidden': 'true' }), nFit + (nFit === 1 ? ' fits' : ' fit') + ' your ' + label + ', shown first']));
    }
    var endFit = nFit && nFit < all.length ? { n: nFit, row: el('li', { class: 'olp-cards__end' }, [
      el('span', { class: 'olp-cards__endt', text: (nFit === 1 ? 'That is the 1 ' + noun(1) + ' listed' : 'That is all ' + nFit + ' ' + noun(2) + ' listed') + ' for your ' + label + '. More ' + what + ' below, including universal parts that may suit it.' })
    ]) } : null;
    if (!nFit && !this.usingPreset) {
      list.appendChild(el('p', { class: 'olp-nomatch' }, [
        'We have not linked any ' + what + ' to your ' + label + ' on the site yet. Every part is still below, and our team can tell you which suit your tub on ',
        el('a', { href: TEL, text: PHONE }), '.'
      ]));
    }
    list.appendChild(el('section', { class: 'olp-group', 'aria-label': 'Parts' }, grid('tub', all, endFit)));
    this.help(list);
  };

  Hub.prototype.help = function (list) {
    list.appendChild(el('p', { class: 'olp-help' }, [
      'Not sure it suits your tub? Call ',
      el('a', { href: TEL, text: PHONE }),
      ' with your hot tub or swim spa make and model and we will confirm before you order.'
    ]));
  };

  Hub.prototype.renderResultsOnly = function () {
    this.fillList(this.results());
  };

  Hub.prototype.render = function () {
    var r = this.root;
    r.innerHTML = '';
    r.appendChild(this.renderTypes());
    r.appendChild(this.renderTubBar());
    r.appendChild(this.renderGrid());
    r.setAttribute('data-ready', '');
  };

  /* ---------- product page ---------- */

  function Pdp(root) {
    var h = root.getAttribute('data-handle');
    var p = null;
    D.parts.forEach(function (x) { if (x.h === h) p = x; });
    if (!p) return;
    var base = root.getAttribute('data-base') || '/collections/hot-tub-parts?view=parts';
    /* While the part pages are being tested on DEV, the panel's links carry ?view=parts like its base. */
    var testView = base.indexOf('view=parts') > -1;
    function pdpTypeUrl(pt, tub) {
      var m = TYPE_META[pt];
      var handle = m && TYPE_PAGES[m.slug] ? TYPE_PAGES[m.slug] : HUB_HANDLE;
      var q = new URLSearchParams();
      if (testView) q.set('view', 'parts');
      if (m && !TYPE_PAGES[m.slug]) q.set('type', m.slug);
      if (tub && tub.brand) {
        q.set('pt', slug(tub.pt || 'Hot tub')); q.set('brand', slug(tub.brand));
        if (tub.range) q.set('range', slug(tub.range));
        if (tub.year) q.set('year', slug(tub.year));
      }
      var qs = q.toString();
      return '/collections/' + handle + (qs ? '?' + qs : '');
    }

    /* New-standard title (shadow). */
    document.querySelectorAll('h1, .product-single__title-text').forEach(function (t) {
      if (!p.t || t.closest('.olp')) return;
      t.setAttribute('data-olp-old', t.textContent.trim());
      t.textContent = p.t;
    });

    /* Sit the panel straight under the product details, above recommendations. */
    var anchor = document.querySelector('.section--product-single');
    if (anchor && anchor.parentNode) anchor.parentNode.insertBefore(root, anchor.nextSibling);

    var sum = fitSummary(p);
    var saved = store(true);
    var lvl = saved && saved.brand ? fitLevel(p, { pt: saved.pt, brand: saved.brand, range: saved.range, year: saved.year }) : null;

    var fitList = el('ul', { class: 'olp-fitlist' });
    sum.lines.forEach(function (l) {
      fitList.appendChild(el('li', {}, [
        BRAND_LOGOS[l.brand] && !TEXT_BRANDS[l.brand] ? el('img', { class: 'olp-fitlist__logo', src: BRAND_LOGOS[l.brand], alt: l.brand, loading: 'lazy' }) : el('strong', { class: 'olp-fitlist__b', text: l.brand }),
        el('span', { class: 'olp-fitlist__r', text: l.bits.length ? l.bits.join(' · ') : 'Several models, call us to confirm yours' })
      ]));
    });
    if (sum.universal) fitList.appendChild(el('li', {}, [el('strong', { class: 'olp-fitlist__b', text: 'Universal' }), el('span', { class: 'olp-fitlist__r', text: 'Suits most hot tubs that take this size and type of part' })]));

    var mine = null;
    if (saved && saved.brand) {
      var yes = lvl === 'fit' || lvl === 'universal';
      mine = el('p', { class: 'olp-mine ' + (yes ? 'olp-mine--yes' : 'olp-mine--ask') }, yes ? ['Fits your saved tub: ' + tubLabel(saved) + '.'] : [
        lvl === 'brand' ? 'This may fit your ' + tubLabel(saved) + ', so check with us before you order. ' : 'Your saved tub is a ' + tubLabel(saved) + '. ',
        el('a', { href: pdpTypeUrl(p.pt, saved), text: 'See ' + ((TYPE_META[p.pt] || {}).short || 'parts').replace(/^./, function (c) { return c.toLowerCase(); }) + ' that fit it' })
      ]);
    }

    var made = madeKey(p.s);
    var signs = SIGNS[p.pt] || [];
    var panel = el('section', { class: 'olp-pdp', 'aria-labelledby': 'olp-pdp-h' }, [
      el('div', { class: 'olp-pdp__fit' }, [
        el('div', { class: 'olp-pdp__top' }, [
          el('h2', { class: 'olp-pdp__h', id: 'olp-pdp-h', text: 'Will it fit my tub?' }),
          p.s ? el('span', { class: 'olp-card__badge olp-card__badge--' + made, text: makerText(p.s) }) : null
        ]),
        sum.lines.length || sum.universal ? fitList : el('p', { class: 'olp-pdp__none', text: 'Tell us your tub and we will confirm this part for you.' }),
        p.nt ? el('p', { class: 'olp-pdp__note' }, [el('strong', { text: 'Good to know: ' }), p.nt.replace(/\.$/, '') + '.']) : null,
        mine,
        el('p', { class: 'olp-pdp__help' }, ['Not sure it suits your tub? Call ', el('a', { href: TEL, text: PHONE }), ' with your hot tub or swim spa make and model and we will confirm before you order.'])
      ]),
      el('div', { class: 'olp-pdp__side' }, [
        el('h3', { class: 'olp-pdp__h3', text: 'Part details' }),
        el('dl', { class: 'olp-dl' }, [
          p.n ? el('div', {}, [el('dt', { text: 'Part number' }), el('dd', { text: p.n })]) : null,
          !p.s ? null : el('div', {}, [el('dt', { text: 'Made by' }), el('dd', { text: made === 'ol' ? 'Outdoor Living (our own brand)' : p.s.replace(/^Genuine /, '') + (made === 'genuine' ? ' (genuine part)' : '') })]),
          el('div', {}, [el('dt', { text: 'Part type' }), el('dd', {}, [el('a', { href: pdpTypeUrl(p.pt, null), text: (TYPE_META[p.pt] || {}).short || p.pt })])])
        ]),
        signs.length ? el('h3', { class: 'olp-pdp__h3', text: 'Signs it needs replacing' }) : null,
        signs.length ? el('ul', { class: 'olp-signs' }, signs.map(function (x) { return el('li', { text: x }); })) : null
      ])
    ]);
    root.appendChild(panel);
    root.setAttribute('data-ready', '');
  }

  /* ---------- boot ---------- */

  /* logos that are unreadable at tile size show the name instead */
  var TEXT_BRANDS = { 'Arctic Spas': true };

  function headerOffset() {
    var h = document.querySelector('.sticky-header');
    var b = h ? h.getBoundingClientRect().bottom : 0;
    return Math.max(0, b) + 16;
  }

  function jumpTo(el, smooth) {
    if (!el) return;
    var y = el.getBoundingClientRect().top + window.pageYOffset - headerOffset();
    window.scrollTo({ top: Math.max(0, y), behavior: smooth ? 'smooth' : 'auto' });
    /* the sticky header can change height once the page scrolls, so line up again when scrolling stops */
    var last = -1, still = 0, tries = 0;
    var t = setInterval(function () {
      var now = window.pageYOffset;
      still = Math.abs(now - last) < 1 ? still + 1 : 0;
      last = now;
      if (still >= 2 || ++tries > 30) {
        clearInterval(t);
        var gap = el.getBoundingClientRect().top - headerOffset();
        if (Math.abs(gap) > 4) window.scrollBy(0, gap);
      }
    }, 80);
  }

  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[href^="#olp-"]');
    if (!a) return;
    var t = document.getElementById(a.getAttribute('href').slice(1));
    if (!t) return;
    e.preventDefault();
    jumpTo(t, true);
    if (history.replaceState) history.replaceState(null, '', a.getAttribute('href'));
  });

  function stickyTop() {
    var top = headerOffset();
    if (window.pageYOffset < 5) { var h = document.querySelector('.sticky-header'); if (h) top = Math.ceil(h.offsetHeight) + 16; }
    document.documentElement.style.setProperty('--ocf-top', top + 'px');
  }

  function boot() {
    document.documentElement.classList.add('ocf-js');
    if (document.querySelector('[data-olp="hub"]')) {
      stickyTop();
      window.addEventListener('scroll', function () { if (!boot.f) boot.f = requestAnimationFrame(function () { boot.f = 0; stickyTop(); }); }, { passive: true });
      window.addEventListener('resize', stickyTop);
    }
    var logos = document.getElementById('olp-logos');
    if (logos) { try { BRAND_LOGOS = JSON.parse(logos.textContent); } catch (e) { BRAND_LOGOS = {}; } }
    var hub = document.querySelector('[data-olp="hub"]');
    if (hub) new Hub(hub);
    var pdp = document.querySelector('[data-olp="pdp"]');
    if (pdp) Pdp(pdp);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
